/* eslint-disable tsdoc/syntax */
import _ from "lodash";

import { useAppStepperContext } from "@zenith/context";

/**
 * The main hook for the Sign Up Stepper.
 * @returns The activeStep prop, and the setOperativeStep, setMaxStep, nextStep, prevStep functions.
 */
const useAppStepper = () => {
  const {
    setActiveStep,
    setMaxStep,
    appStepperContext: { activeStep, maxStep },
  } = useAppStepperContext();

  /**
   * Sets the active step on the Sign Up Stepper.
   * @param activeStep The desired active step.
   */
  const setOperativeStep = (activeStep: number): void => {
    if (!_.inRange(activeStep, 0, maxStep)) {
      throw new Error(`The value ${activeStep} is not in range.`);
    }

    setActiveStep(activeStep);
  };

  /**
   * Goes to the next step on the Sign Up Stepper.
   */
  const nextStep = (): void => {
    const nextStep = activeStep + 1;
    setActiveStep(nextStep);
  };

  /**
   * Goes to the previous step on the Sign Up Stepper.
   */
  const prevStep = (): void => {
    const prevStep = activeStep - 1;

    if (!_.inRange(prevStep, 0, maxStep)) {
      throw new Error(`The value ${prevStep} is not in range.`);
    }

    setActiveStep(prevStep);
  };

  return {
    activeStep,
    setOperativeStep,
    setMaxStep,
    maxStep,
    nextStep,
    prevStep,
    setActiveStep,
  };
};

export default useAppStepper;
